<template>
  <div>

    <div class="card">

      <div class="card-header bg-transparent">

        <div class="row">
          <div class="col-6">
            <h3 class="card-title mb-0"> {{$t('fatura.teklif')}} </h3>
              <small class="md-truncate flex">{{$t('fatura.teklifaciklama')}}</small>
          </div>

          <div class="col-6 mt-2">
            <el-button-group class="pull-right">
              <el-tooltip :content="$t('yeni')" placement="bottom">

                <router-link type="success" size="mini" circle to="/teklif/fatura/yeni">
                  <i class="el-icon-plus"></i>
                </router-link>
              </el-tooltip>
            </el-button-group>

          </div>
        </div>

      </div>


      <div class="card-body">
        <el-col :span="24">
          <el-table
            :data="veri()"
            @selection-change="handleSelectionChange"
            style="width: 100%">

            <el-table-column
              type="selection"
              width="40">
            </el-table-column>

            <el-table-column
              :label="$t('fatura.cariadi')"
              prop="cari">
            </el-table-column>


            <el-table-column
              :label="$t('fatura.aciklama')"
              prop="aciklama">
            </el-table-column>

            <el-table-column
              :label="$t('fatura.kategori')"
              prop="kategori">
            </el-table-column>

            <el-table-column
              :label="$t('fatura.dtarih')"
              prop="dtarihi">
            </el-table-column>


            <el-table-column
              :label="$t('fatura.durum')"
              prop="toplam">
              <template slot-scope="Data">
                <el-tag :type="Data.row.odurum==0 || Data.row.odurum==2?'danger':'success'">
                  <p v-if="Data.row.odurum==='0'">{{$t('fatura.odenmedi')}}</p>
                  <p v-if="Data.row.odurum==='1'">{{$t('fatura.odendi')}}</p>
                  <p v-if="Data.row.odurum==='2'">{{$t('fatura.iptal')}}</p>
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('fatura.tutar')"
              prop="toplam">
              <template slot-scope="Data">
                <el-tag type="success">
                  <p>{{Data.row.toplam}}</p>
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              align="right">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  :placeholder="$t('ara')"/>
              </template>
              <template slot-scope="scope">
                <!--el-tooltip :content="$t('duzenle')" placement="right">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"><i class="i-Brush"></i>
                  </el-button>
                </el-tooltip-->
                <el-tooltip :content="$t('fatura.bas2')" placement="right">
                  <el-button
                    size="mini"
                    type="warning"
                    @click="handleView(scope.$index, scope.row)"><i class="i-Eye"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip :content="$t('sil')" placement="right">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, Data, scope.row)"><i class="i-Folder-Trash"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        Data: [],
        search: '',
      }
    },
    methods: {
      veri() {
        if (this.Data != null) {
          var veri = this.Data.filter(data => !this.search || data.adi.toLowerCase().includes(this.search.toLowerCase()))
        } else if (this.Data == '') {
          var veri = this.Data;
        }
        return veri
      },

      FaturaListele() {
        var tur = 3; // tur 1 ise gider 2 ise gelir
        this.$store.dispatch("dataver", {method: "get", url: "/fatura/" + tur})
          .then(response => {
            console.log(response.Data)
            if (response.Status == 'OK') {
              this.Data = response.Data;
            } else {

            }
          });
      },

      handleView(index, row) {
        this.$router.push('/gelir/fatura/detay/' + row.id);
      },
      handleEdit(index, row) {
        console.log(row.id)
        this.$router.push('/gelir/fatura/duzenle/' + row.id);
      },
      handleDelete(index, row, rows) {

        this.$confirm(this.$t('siluyari.0'), '', {
          confirmButtonText: this.$t('tmm'),
          cancelButtonText: this.$t('iptal'),
          type: 'warning'
        }).then(() => {

          row.splice(index, 1);
          this.$store.dispatch("Delete", {link: 'fatura', id: rows.id}).then(response => {
            if (response.Status == 'OK') {
              this.$message({
                type: 'success',
                message: this.$t('siluyari.1')
              });
            } else {
              this.$message({
                type: 'danger',
                message: response.Status
              });
            }
          });


        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('siluyari.2')
          });
        });


      },
      handleSelectionChange(val) {
        this.Secilen = val;
        console.log(val)
        //this.st.ToplamTutar = this.Secilen.reduce((acc, item) => acc + Number(item.Tutar), 0).toFixed(2);
        //this.st.ToplamZam = this.Secilen.reduce((acc, item) => acc + Number(item.ZamTutar), 0).toFixed(2);
        //this.st.ToplamOdenecek = (Number(this.st.ToplamTutar) + Number(this.st.ToplamZam)).toFixed(2);
      },


    },
    created() {
      this.FaturaListele();
    }
  }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/teklif/fatura/liste.vue